import { render, staticRenderFns } from "./IviewFormModal.vue?vue&type=template&id=d78afa90&scoped=true&"
import script from "./IviewFormModal.vue?vue&type=script&lang=js&"
export * from "./IviewFormModal.vue?vue&type=script&lang=js&"
import style0 from "./IviewFormModal.vue?vue&type=style&index=0&id=d78afa90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78afa90",
  null
  
)

export default component.exports